import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSetTopbarTitle } from '../layout/pageChrome'

/** Cabeçalho de página: o título/eyebrow sobem para o Topbar (libera a área útil do
 *  corpo); no corpo fica só a ação (e o subtítulo, se houver). Sem ação nem
 *  subtítulo → não renderiza nada. */
export function PageHeader({
  title,
  eyebrow,
  subtitle,
  leading,
  action,
}: {
  title: string
  eyebrow?: string
  subtitle?: string
  /** Conteúdo à esquerda da linha de ações, no lugar do subtítulo: a faixa
   *  de indicadores das grades integradas. Indicadores e ações na mesma linha
   *  é o que deixa o cabeçalho em duas linhas em vez de três. */
  leading?: React.ReactNode
  action?: React.ReactNode
}) {
  useSetTopbarTitle(title, eyebrow)
  if (!action && !subtitle && !leading) return null
  const esquerda = leading ?? (subtitle ? (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {subtitle}
    </Typography>
  ) : null)
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: esquerda ? 'space-between' : 'flex-end',
        gap: 2,
        flexWrap: 'wrap',
        mb: 2,
      }}
    >
      {esquerda && <Box sx={{ minWidth: 0 }}>{esquerda}</Box>}
      {/* Quando não cabe ao lado dos indicadores, a linha de ações quebra e
          continua encostada à direita. */}
      {action && <Box sx={{ ml: 'auto' }}>{action}</Box>}
    </Box>
  )
}
